import { render, staticRenderFns } from "./BasePaginatedSelect.vue?vue&type=template&id=35466692&scoped=true"
import script from "./BasePaginatedSelect.vue?vue&type=script&lang=js"
export * from "./BasePaginatedSelect.vue?vue&type=script&lang=js"
import style0 from "./BasePaginatedSelect.vue?vue&type=style&index=0&id=35466692&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35466692",
  null
  
)

export default component.exports